const SubmitLoader = ({ isSubmitting = false }) => {
    return isSubmitting
        ? <div className="absolute top-0 left-0 z-10 h-full w-full bg-[#0001] before:absolute before:top-0 before:left-0 before:h-full before:w-full before:backdrop-blur-md">
            <div className="absolute top-1/2 left-1/2 w-3/6 -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white px-6 py-8 lg:w-1/5">
                <div className="flex items-center justify-center">
                    <div className="typing__dot"></div>
                    <div className="typing__dot"></div>
                    <div className="typing__dot"></div>
                </div>
            </div>
        </div>
        : <></>

}

export default SubmitLoader